// extracted by mini-css-extract-plugin
export default {"certificate":"nQ9sfOpLhMpBMDjHyQ8b","title":"PUUi_FDiHknZfS1JLKfg","content":"fKYeV6ICm5_eBcTZ5uww"};